let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("del2V")).then(() => parcelRequire('eHqVt'));